var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.256,
    height: 26.256,
    viewBox: "0 0 26.256 26.256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M25.487,5.432a.769.769,0,0,0,.769-.769V.769A.769.769,0,0,0,25.487,0H21.593a.769.769,0,0,0-.769.769V1.947H5.432V.769A.769.769,0,0,0,4.663,0H.769A.769.769,0,0,0,0,.769V4.663a.769.769,0,0,0,.769.769H1.947V20.824H.769A.769.769,0,0,0,0,21.593v3.894a.769.769,0,0,0,.769.769H4.663a.769.769,0,0,0,.769-.769V24.31H20.824v1.178a.769.769,0,0,0,.769.769h3.894a.769.769,0,0,0,.769-.769V21.593a.769.769,0,0,0-.769-.769H24.31V5.432ZM22.363,1.538h2.355V3.894H22.363Zm-20.824,0H3.894V3.894H1.538ZM3.894,24.718H1.538V22.363H3.894Zm20.824,0H22.363V22.363h2.355Zm-1.947-3.894H21.594a.769.769,0,0,0-.769.769v1.178H5.432V21.593a.769.769,0,0,0-.769-.769H3.485V5.432H4.663a.769.769,0,0,0,.769-.769V3.485H20.824V4.663a.769.769,0,0,0,.769.769h1.178V20.824Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M145.3,137.162H134.271a.769.769,0,0,0-.769.769v2.8a.769.769,0,0,0,1.538,0V138.7h3.974v9.214h-1.433a.769.769,0,1,0,0,1.538h4.405a.769.769,0,1,0,0-1.538h-1.433V138.7h3.974v2.028a.769.769,0,0,0,1.538,0v-2.8A.769.769,0,0,0,145.3,137.162Z",
    transform: "translate(-126.656 -130.128)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconText);
export default __webpack_public_path__ + "static/media/icon-text.77c1befbd85e36d9ca361f8826a788c8.svg";
export { ForwardRef as ReactComponent };